import { HttpClient } from '@angular/common/http'
import { Injectable, Optional } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { DateTime } from 'luxon'
import { SharedStateService } from 'src/app/services/shared-state.service'
import { mainDomain } from '../utilities/constants'
import { CookieService } from 'ngx-cookie'
import * as uuid from 'uuid'
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor (
    private http: HttpClient,
    private router: Router,
    private sharedService: SharedStateService,
    @Optional() private cookieService: CookieService
  ) { }

  appCorrelationId () {
    return this.getUserUuid()
  }

  getTestDate (test: any): string {
    let startDate
    const dateFormat = 'yyyy-MM-dd\'T\'HH:mm:ss'
    if (test?.productName?.includes('OSR') && test?.speakingStartDateTimeUtc === '0001-01-01T00:00:00+00:00') {
      startDate = DateTime.fromISO(test?.lrwStartDateTimeUtc)
    } else {
      startDate = DateTime.fromISO(test?.speakingStartDateTimeUtc)
    }
    if (test?.productName?.includes('on Computer')) {
      startDate = startDate.setZone(test?.testLocationTimeZone).toFormat(dateFormat)
    } else {
      startDate = startDate.toFormat(dateFormat)
    }
    return startDate
  }

  getUserUuid () {
    return uuid.v4()
  }

  checkDefaultImage (s3Url: string | any, isPrimary: boolean): boolean {
    const imageSuffix = isPrimary ? 'id-upload-image_1.png' : 'id-upload-image_2.png'
    return s3Url?.includes(imageSuffix)
  }

  isObjNotEmpty (obj: any) {
    return (obj && (Object.keys(obj)?.length))
  }

  is24HourCountry (intime: any, country?: any) {
  if (!intime) return ''
  const time = intime.toLowerCase()
  const countryCode = country ? country.toLowerCase() : ''
  const parsed = DateTime.fromFormat(time.trim(), 'hh:mm a') || DateTime.fromFormat(time.trim(), 'HH:mm') || DateTime.fromISO(time.trim())
  if (!parsed.isValid) return time
  const is24hr = countryCode === 'tur'
  return is24hr ? parsed.toFormat('HH:mm') : parsed.toFormat('hh:mm a')
  }
  formatGtmValue (label?: string): string {
    return label?.toLowerCase().replace(/ /g, '_') || ''
  }

  myTestsRedirectionUrl (): any {
    const mockDetails = this.sharedService.getFromLocalStorage()
    return environment.bxURL + ((mockDetails?.enableNewTestPage) ? '/test-bookings' : '/my-tests')
  }

  /**
   * Removes all agent-related session data (every agent-prefixed sessionStorage
   * key plus the agentTtProfile cookie). Used on agent logout.
   */
  clearAgentSession (): void {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith('agent'))
      .forEach(key => sessionStorage.removeItem(key))
    this.cookieService?.remove('agentTtProfile', { path: '/', domain: mainDomain })
  }
}
